import * as React from 'react';
import { FunctionComponent } from 'react';
import GITextIntl from '../../components/common/app-components/GIText/GITextIntl';

const EligibleMembersHeader: FunctionComponent = () => {
  return (
    <div className='header__eligible-members'>
      <h4>
        <GITextIntl
          messageId='indportal.tobacco.eligibleMembers'
          id='eligible-members'
          data-testid='eligible-members'
        />
      </h4>
    </div>
  );
};

export default EligibleMembersHeader;
